/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsIngestContainerFindingsRequest {
    getFixupPrototypeFunction() { return AppSecopsIngestContainerFindingsRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsIngestContainerFindingsRequest>): AppSecopsIngestContainerFindingsRequest {
        let obj = Object.assign(new AppSecopsIngestContainerFindingsRequest(), model);
        AppSecopsIngestContainerFindingsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsIngestContainerFindingsRequest>): AppSecopsIngestContainerFindingsRequest {
        if (!model) return null;
        return AppSecopsIngestContainerFindingsRequest.newInstance(<AppSecopsIngestContainerFindingsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsIngestContainerFindingsRequest) {
        if (!obj) return;

        models.AppSecopsIngestContainerFindingsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsIngestContainerFindingsRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsIngestContainerFindingsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.container_findings) {
            for (let val of this.container_findings) {
                models.ContainerFindings.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique identifier of the tenant submitting the container security findings
     */
    tenant_id: string;

    /**
     * Unique identifier of the SBOM version to associate the container security findings with
     */
    sbom_version_id: string;

    /**
     * List of container security findings to be ingested, each containing tool information and attachment reference
     */
    container_findings: Array<models.ContainerFindings>;

}
